import React from 'react';
import './Button.css';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost';
  size?: 'small' | 'medium' | 'large';
  fullWidth?: boolean;
  loading?: boolean;
  icon?: React.ReactNode;
  children: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'medium',
  fullWidth = false,
  loading = false,
  icon,
  children,
  className = '',
  disabled,
  ...rest
}) => {
  const buttonClass = `
    button 
    button--${variant} 
    button--${size}
    ${fullWidth ? 'button--full-width' : ''}
    ${loading ? 'button--loading' : ''}
    ${className}
  `.trim();

  return (
    <button 
      className={buttonClass}
      disabled={disabled || loading}
      {...rest}
    >
      {loading && <span className="button__spinner" />}
      {!loading && icon && <span className="button__icon">{icon}</span>}
      <span className="button__content">{children}</span>
    </button>
  );
};